import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import UserNamesAPI from '../api/UserNamesAPI';
import { Handles, PlatformName, readHandles, writeHandles } from '../utils/userSettings';

export type SettingsStateType = {
  handles: Handles;
};

// localStorage is read synchronously, so the handles are in state on the first render and the Player
// filter prefills without a flash.
export const SettingsInitialState: SettingsStateType = {
  handles: readHandles(),
};

// Fills platforms localStorage lacks from the account's saved handles (new device, cleared storage).
// localStorage wins per platform. Signed-in visitors only; the endpoint 401s otherwise.
export const loadHandles = createAsyncThunk('Settings/loadHandles', async () => {
  const saved = await UserNamesAPI.getHandles();
  const merged = { ...saved, ...readHandles() };
  writeHandles(merged);
  return merged;
});

const slice = createSlice({
  name: 'Settings',
  initialState: SettingsInitialState,
  reducers: {
    setHandle: (state, action: PayloadAction<{ platform: PlatformName; username: string }>) => {
      // Persist here so every handle update also survives a reload.
      const { platform, username } = action.payload;
      const handles = { ...state.handles, [platform]: username.trim() };
      writeHandles(handles);
      state.handles = handles;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadHandles.fulfilled, (state, action) => {
      state.handles = action.payload;
    });
    // A rejected load (signed out, offline) keeps what localStorage had.
  },
});

export const { setHandle } = slice.actions;
export default slice.reducer;
